<template>
  <div style="display: inline-block;">
    <a-dropdown>
      <a-menu slot="overlay">
        <a-menu-item v-if="hasMobile" key="1">
          <a :href="'tel:' + mobile">{{ mobile }}</a>
        </a-menu-item>
        <a-menu-item v-if="hasPhone" key="2">
          <a :href="'tel:' + phone">{{ phone }}</a>
        </a-menu-item>
        <a-menu-item v-if="hasWork" key="3">
          <a :href="'tel:' + work">{{ work }}</a>
        </a-menu-item>
      </a-menu>
      <a-button v-on:click.stop>
        <phone-icon></phone-icon>
        Bellen
      </a-button>
    </a-dropdown>
  </div>
</template>

<script>
export default {
  name: "CustomerCallButtonComponent",
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasMobile() {
      return this.customer.mobile !== null && this.customer.mobile.length > 0;
    },
    hasPhone() {
      return this.customer.phone !== null && this.customer.phone.length > 0;
    },
    hasWork() {
      return this.customer.phone_work !== null && this.customer.phone_work.length > 0;
    },
    mobile() {
      return this.customer.mobile;
    },
    phone() {
      return this.customer.phone;
    },
    work() {
      return this.customer.phone_work;
    }
  }
}
</script>